
const { customValid } = require('../../utils/validator')

import { mapState, mapActions, mapMutations } from 'vuex'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Checker from 'vux/src/components/checker/checker.vue'
import CheckerItem from 'vux/src/components/checker/checker-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'

import questionIcon from 'assets/icons/icon-customer-service@3x.png'
import iconKefu from 'assets/icons/icon_kefu1@3x.png'
import isValid from '../../utils/validor'
import editIcon from 'assets/icons/icon_often_edit@3x.png'
import Long from 'long'

export default {
name: 'CustomEdit',
components: {
XHeader,
XNumber,
XInput,
Datetime,
Group,
Checker,
CheckerItem,
XButton,
XTextarea,
},
data() {
return {
questionIcon,
iconKefu,
editIcon,
initCustomOrderData: {
customId: 0,
personCount: 2,
services: [],
contactInfo: {
id: '',
name: null,
mobile: null,
},
departureStart: null,
remark: null,
},

minCount: 1,
meiqiaCustomAgentId: 'ccee449fdec53b449cb1c86e03839f49',
}
},
computed: {
...mapState({
customRoute: ({ custom }) => custom.customRoute,
services: ({ custom }) => custom.services,
attn: ({ attn }) => attn.commonAttn,
customOrderData: ({ order }) => order.customOrderData,
}),
categoryName() {
if (this.customRoute.category && this.customRoute.category.name) {
return `${this.customRoute.category.name}定制`
}
return '观赛日定制'
},
hasAttn() {
if (this.customOrderData.contactInfo.id) {
return true
}
if (this.attn.id) {
this.customOrderData.contactInfo = this.attn
return true
}
return false
},
},
methods: {
...mapMutations({
saveCustomOrderData: 'SAVE_CUSTOM_ORDER_DATA',
}),
...mapActions(['fetchUserCommonAttnByUserId', 'fetchCustomOrderServices', 'fetchCustomRouteById', 'fetchBasicConfig', 'showToast']),
routeTo(route) {
this.$router.push(route)
},
mutateOrder() {
const { customId } = this.$route.params
const self = this
self.customOrderData.customId = customId
self.saveCustomOrderData(self.customOrderData)
},
goToAttn(type, attnId) {
const query = { from: 'customOrder' }
if (attnId) {
query.id = attnId
} else {
query.type = 'attn'
}
this.mutateOrder()
this.$router.push({
name: `attn-${type}`,
query,
})
},
defaultDate() {
const { kind } = this.$route.query
if (kind === 0) {
const date = this.customRoute.matchTime
const timestamp = new Long(date.low, date.high, date.unsigned).toNumber() - 259200000
this.customOrderData.departureStart = this.formateDate(timestamp)
} else {
this.customOrderData.departureStart = this.formateDate(Date.now() + 5184000000)
}
},
formateDate(timestamp) {
const date = new Date(timestamp)
const year = date.getFullYear()
const month = date.getMonth() + 1
const day = date.getDate()
return `${year}-${month}-${day}`
},
placeCustomOrder() {
const self = this

const { kind } = this.$route.query

const { userId } = this.$jwt
const { city } = this.customRoute
const { contactInfo: { name, mobile }, departureStart, personCount,
services, remark } = this.customOrderData

if (new Date(departureStart) < Date.now()) {
self.showToast({
content: '请选择当前日期以后的日期！',
size: '18em',
})
return
}

const mobileValid = customValid.apply(self, [mobile, null, '请输入联系人手机号'])
const contactNameValid = customValid.apply(self, [name, null, '请输入联系人姓名'])
const departureStartValid = customValid.apply(self, [departureStart, null, '请选择出发日期'])

if (!departureStartValid || !contactNameValid || !mobileValid) {
return
}

if (!isValid('mobile', mobile)) {
self.showToast({
content: '手机号码填写有误，请输入11位国内手机号码！',
size: '21em',
time: 3000,
})
return
}

const req = {
userId,
city,
departureStart: new Date(departureStart).getTime(),
personCount: +personCount,
services,
contactInfo: {
name,
mobile,
},
remark,
}

if (+kind === 0) {
req.matchRouteId = this.customRoute.id
} else {
req.sportsRouteId = this.customRoute.id
}

this.$http.post('/api/custom/placeOrder', req).then(res => res.json())
.then(() => {
self.$router.push({
name: 'order-list',
query: { listType: 2 },
})
})
.catch((err) => {
self.showToast({
content: err.body.resultInfo,
})
})
},
chat() {
window._MEIQIA('showPanel') 
},
},
created() {
document.title = '提交定制需求'

const { kind } = this.$route.query
const { customId } = this.$route.params
let params
if (+kind === 0) {
params = {
matchRouteId: +kind,
}
} else {
params = {
sportsRouteId: +kind,
}
}

this.fetchUserCommonAttnByUserId(this.$jwt.userId)
this.fetchCustomOrderServices(params)
this.fetchCustomRouteById({
kind,
customId,
}).then(() => {
if (+customId !== +this.customOrderData.customId) {
this.saveCustomOrderData(this.initCustomOrderData)
this.defaultDate()
}
})
this.fetchBasicConfig().then((data) => {
this.meiqiaCustomAgentId = data.meiqiaCustomAgentId
})
},
}



// WEBPACK FOOTER //
// ./client/components/Custom/CustomEdit.vue